// src/components/ui/SearchInput.js
import React, { useState } from 'react';
import { Search } from 'lucide-react';

const SearchInput = ({
  searchTerm = '',
  onSearchChange,
  placeholder = "Search...",
  collapsed = false,
  dark = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // Don't render when collapsed
  if (collapsed) return null;

  return (
    <div>
      {/* Main input container with hover/focus states */}
      <div
        className={`relative rounded-app-sm transition-all duration-app-normal w-full ring ${
          dark
            ? `bg-app-gray-800 ring-app-gray-500 ${isFocused ? 'ring-2' : 'ring-1'}`
            : `bg-app-white ring-app-gray-900 ${isFocused ? 'ring-2' : 'ring-1'}`
        }`}
        style={{ height: '32px' }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Background layer - appears on hover, expands on focus */}
        <div
          className={`
            absolute rounded-app-sm ${dark ? 'bg-app-gray-700' : 'bg-app-gray-300'}
            ${isFocused ? 'transition-all duration-app-normal' : ''}
            ${isFocused
              ? 'inset-0'
              : isHovered
                ? 'inset-[3px]'
                : 'inset-0 opacity-0'
            }
          `}
        />

        {/* Input content - always on top */}
        <div className="relative z-10 flex items-center px-app-sm h-full">
          <Search
            size={14}
            strokeWidth={2}
            className="mr-app-sm mb-[2px] flex-shrink-0"
            style={{
              color: dark ? '#707A84' : (isHovered || isFocused ? '#8F99A3' : '#C0C7CE')
            }}
          />
          <input
            type="text"
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => onSearchChange?.(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            className={`
              flex-1 min-w-0 bg-transparent border-none outline-none
              ${dark ? 'text-app-white' : 'text-app-gray-900'} text-app-sm font-normal
              placeholder:font-normal
              ${dark
                ? 'placeholder:text-app-gray-600'
                : isHovered || isFocused
                  ? 'placeholder:text-app-gray-500'
                  : 'placeholder:text-app-gray-400'
              }
            `}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchInput;